export const Config = {
  NDX_ACCOUNTS_SERVICE_URL: import.meta.env.NDX_ACCOUNTS_SERVICE_URL,
  NDX_RECOMMENDATIONS_URI: import.meta.env.NDX_RECOMMENDATIONS_URI,
  MODE: import.meta.env.MODE,
  VITE_RELEASE: import.meta.env.VITE_RELEASE
};

export type ConfigType = typeof Config;
